export enum EnumTipoOperacaoCardapio {
    MESACOMANDA = 1,
    MESA = 2,
    VISUALIZACAO = 3,
}